/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ChangePatientInformationAliases {
  AUTOCOMPLETE_DEPARTMENTS = 'autocomplete-departments',
  BARCODE_COMPONENT_LOCAL_PA = 'barcode-component-local-pa',
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_CONFIRM = 'button-confirm',
  CONTEXTUAL_BAR_LAYOUT = 'contextual-bar-layout',
  CONTEXTUAL_BAR_PATIENT = 'contextual-bar-patient',
  FETCH_DEPARTMENTS = 'fetch-departments',
  FIELD_DEPARTMENTS = 'field-departments',
  FILTER_FIELD_DEPARTMENTS = 'filter-field-departments',
  FRAGMENT_REFERENCE_INFORMATION_BAR = 'fragment-reference-information-bar',
  GLOBAL_ACTIONS_1 = 'global-actions-1',
  LAYOUT_LOADER = 'layout-loader',
  LAYOUT_MAIN_CHANGE_LOCATION = 'layout-main-change-location',
  LAYOUT_PATIENT = 'layout-patient',
  LOADER = 'loader',
  MAPPER_DEPARTMENTS = 'mapper-departments',
  MODAL = 'modal',
  PANEL_LOADER = 'panel-loader',
  PANEL_MODAL = 'panel-modal',
  PANEL_PATIENT = 'panel-patient',
  TEXT_DEPARTMENTS = 'text-departments',
}
export { ChangePatientInformationAliases };
